import { FC } from 'react'
import { Icons } from '../../..'
import { ToastPrimitive } from '../primitives'
import { ToastInstance } from '../types'

export const ToastElement: FC<{ instance: ToastInstance }> = ({ instance }) => {
  if ('customJsx' in instance) {
    return <>{instance.customJsx}</>
  }

  const { ttl, title, description, action, dismissable, variant } = instance
  const handleClick = () => action?.onClick && action.onClick(instance)
  const ttlSeconds = ttl * 1000

  return (
    <ToastPrimitive.Root duration={ttlSeconds} variant={variant}>
      {title && (
        <ToastPrimitive.Title data-cy={`toast-title-${variant}`}>{title}</ToastPrimitive.Title>
      )}
      {description && (
        <ToastPrimitive.Description data-cy={`toast-description-${variant}`}>
          {description}
        </ToastPrimitive.Description>
      )}
      {action && (
        <ToastPrimitive.Action altText={action.label} onClick={handleClick} variant={variant}>
          {action.label}
        </ToastPrimitive.Action>
      )}
      {dismissable && (
        <ToastPrimitive.Close data-cy="close-toast-button">
          <Icons.Close />
        </ToastPrimitive.Close>
      )}
    </ToastPrimitive.Root>
  )
}
